import { fromJS } from 'immutable'; // import MAP_STYLE from './style'
// import MAP_STYLE from './monochromeStyle'

import MAP_STYLE from './cpalStyle';
export var defaultMapStyle = fromJS(MAP_STYLE);